export default __webpack_public_path__ + "static/media/Btn_View_Process.1ba8bd61.svg";